export type IGetTimeFormatPositions = (
  timeFormat: string
) => {
  [key: string]: number;
  h: number;
  m: number;
  s: number;
  t: number;
  z: number;
};

export function getTimeFormatPositions(
  timeFormat: string
): {
  [key: string]: number;
  h: number;
  m: number;
  s: number;
  t: number;
  z: number;
} {
  const finds = timeFormat.toLowerCase().match(/(h{1,2}|m{1,2}|s{1,2}|t{1,2}|z)/g);
  const orders: {
    [key: string]: number;
    h: number;
    m: number;
    s: number;
    t: number;
    z: number;
  } = {
    h: -1,
    m: -1,
    s: -1,
    t: -1,
    z: -1,
  };

  if (finds) {
    for (let i = 0; i < finds.length; i += 1) {
      if (orders[finds[i].toString().charAt(0)] === -1) {
        orders[finds[i].toString().charAt(0)] = i + 1;
      }
    }
  }

  return orders;
}
